const styles = theme => ({
  objectivesMomentsContainer: {
    width: '100%',
    height: 'min-content',
    padding: theme.spacing.unit * 4,
  },
  objectivesMomentsPaper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 3,
  },
  header: {
    alignItems: 'center',
    '& h5': {
      fontWeight: 500,
    },
  },
  button: {
    marginLeft: 'auto',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 5}px`,
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '1.1rem',
    marginRight: '16px',
  },
  sectionSubtitle: {
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  objectiveContainer: {
    alignItems: 'center',
    textTransform: 'capitalize',
    padding: `0 ${theme.spacing.unit}px`,
  },
  caseTypesSelect: {
    margin: `${theme.spacing.unit * 3} 0 ${theme.spacing.unit * 5}`,
    width: '32ch',
  },
  // name-left / pill-right needs an explicit full width (v3 MenuItem is
  // width:'auto', overriding ListItem's 100%), and border-box is load-bearing:
  // MenuItem is content-box with 16px gutters, so a plain width:100% renders the
  // row 32px wider than the menu paper and its overflow:hidden shears the
  // right-aligned pill. Switching to border-box also reinterprets MenuItem's
  // height:24, which would collapse the row — hence the explicit minHeight.
  caseTypeMenuItem: {
    boxSizing: 'border-box',
    width: '100%',
    height: 'auto',
    minHeight: 46,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  // the name yields (ellipsis) before the pill does — a truncated objective name
  // is readable, a sheared pill is not
  caseTypeMenuItemLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // v3 Chip has no size prop and hardcodes height 32, which a 24px content-box
  // MenuItem shears — shrink it locally instead
  minPanelistsPill: {
    height: 20,
    flexShrink: 0,
    fontSize: '0.75rem',
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[800],
    '& span': {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
  },
  notchedOutline: {
    borderColor: `${theme.palette.border ? theme.palette.border.main : 'initial'} !important`,
  },
  errorOutline: {
    borderColor: `${theme.palette.secondary.main} !important`,
  },
  selectIcon: {
    marginRight: theme.spacing.unit * 3,
  },
  selectMenu: {
    maxHeight: '500px',
  },
  warningModal: {
    padding: theme.spacing.unit * 4,
  },
  warningTitle: {
    fontWeight: 500,
    fontSize: '1.5rem',
  },
  warningText: {
    fontSize: '1.1rem',
    margin: `${theme.spacing.unit * 4} 0`,
  },
  warningButtonsContainer: {
    gridGap: `${theme.spacing.unit * 2}px`,
    '& > button': {
      flexGrow: 1,
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
    },
  },
  emptyObjectivesContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4,
    gridGap: `${theme.spacing.unit}px`,
    background: theme.palette.grey[50],
    '& h6': {
      fontWeight: 500,
      color: theme.palette.grey[800],
    },
    '& p': {
      color: theme.palette.grey[600],
      fontSize: '1rem',
      width: '52ch',
      textAlign: 'center',
    },
  },
  awardCompensationQuestion: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#333333',
    opacity: 0.9,
  },
  awardCompensationError: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: '#F44336',
    opacity: 0.9,
  },
  answerLabel: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '15px',
    letterSpacing: '-0.02em',
    color: '#292D32',
    opacity: 0.8,
    marginBottom: '8px',
  },
  awardAnswerContainer: {
    display: 'flex',
    gap: '12px',
    padding: '24px 0 12px 0',
    flexWrap: 'wrap',
  },
})

export default styles
